import { readonly, ref } from 'vue'

const organizationModules = ref<string[]>([])

export const useOrganizationModules = (): any => {
  const updateOrganizationModules = (modules: string[]) => {
    organizationModules.value = modules
  }
  return {
    organizationModules: readonly(organizationModules),
    updateOrganizationModules,
  }
}
